import React from "react";
import Button from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import { useState, useEffect } from "react";
import BusinessModalComponent from "../Models/businessUnitModal";
import DeleteModal from "../Models/Delete/DeleteModal";
import "../App.css";
import {
  DeleteButton,
  EditButton,
  paddingAndMargin,
  paginationstyle,
  screenHeaderStyle,
  UpperLowerText,
  useSharedValue,
} from "../Constants/constants";
import { BASE_URL } from "../../App_Settings/app_settings";
import { formatDate } from "../../Utility/utility";
import LoaderIndicator from "../../Utility/loading";
import {
  ConditionalPagination,
  paginationStyles,
  useDynamicRowsPerPage,
} from "../../utils/paginationUtils";
import SearchInput from "../Constants/search_input";
import { getUserIdFromLocalStorage } from "../../API_Endpoints/APIEndpoints";

// const columns = [
//   { field: 'businessUnit', headerName: 'Business Unit', type: 'string' },
// ];
const columns = [
  // { field: 'id', headerName: 'ID', type: 'string' },

  { field: "name", headerName: "Client", type: "string" },
  { field: "adminUrl", headerName: "Admin URL", type: "string" },
  // { field: 'isDefault', headerName: 'Default', type: 'boolean' },
  { field: "createdBy", headerName: "Created By", type: "string" },
  { field: "createdDate", headerName: "Created Date", type: "string" },
  { field: "modifiedBy", headerName: "Modified By", type: "string" },
  { field: "modifiedDate", headerName: "Modified Date", type: "string" },
  // { field: 'organizationId', headerName: 'Organization ID', type: 'string' },
  // { field: 'isDeleted', headerName: 'Is Deleted', type: 'boolean' },
  { field: "functions", headerName: "", type: "string" },
];

export default function BusinessUnit() {
  const [searchValue, setSearchValue] = React.useState("");
  const [isInputActive, setInputActive] = React.useState(false);
  const [editingData, setEditingData] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [title, setTitle] = React.useState();
  const [rows, setRows] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectDeletedItem, setSelectDeletedItem] = useState(null);
  const currentTimestamp = new Date();
  const [loading, setLoading] = useState(true);
  const { isMenuOpen } = useSharedValue();
  const { getBusinessUnits, handleSetValueDefaultBusinessunit, defaultBusinessunit } =
    useSharedValue();
  const seconds = currentTimestamp.getSeconds();

  const [startIndex, setStartIndex] = useState(0); // Initial rows per page value
  const [currentPage, setCurrtPage] = useState(1); // Current page number
  const { ref: scrollContainerRef, rowsPerPage: dynamicRowsPerPage } = useDynamicRowsPerPage();
  const [endIndex, setEndIndex] = useState(dynamicRowsPerPage);
  const { numberOfSelectedRows, updateRowNumberOfPages } = useSharedValue();

  const handleInputFocus = () => {
    setInputActive(true);
  };

  const handleInputBlur = () => {
    setInputActive(false);
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setEditingData(null);
    setOpen(false);
  };
  const handleEdit = (id, businessUnit, isDefault) => {
    setEditingData({ id, businessUnit, isDefault });
    handleOpen();
  };

  // Modify the handleSave method to check if editingData exists. If it does, we're updating an existing row, otherwise, we're adding a new one.
  const handleSave = (newData) => {
    if (editingData) {
      const userDataJSON = localStorage.getItem("token");
      console.log(userDataJSON);

      if (userDataJSON) {
        const userData = JSON.parse(userDataJSON);
        if (newData.isDefaultChecked === true) {
          handleSetValueDefaultBusinessunit(newData.businessUnit);
          setRows((prevRows) =>
            prevRows.map((row) => ({
              ...row,
              isDefault: row.id === newData.id,
            }))
          );
        }

        setRows((prevRows) =>
          prevRows.map((row) =>
            row.id === newData.id
              ? {
                  ...row,
                  ...newData,
                  name: newData.businessUnit,
                  isDefault: newData.isDefaultChecked,
                  createdBy: userData.userName,
                  createdDate: new Date().toISOString().substring(0, 25),
                }
              : row
          )
        );
        const data = {
          businessUnitId: newData.id,
          name: newData.businessUnit,
          adminUrl: newData.adminUrl,
          isDefault: newData.isDefaultChecked,
          modifiedBy: userData.userName,
          delete: false,
          organizationId: newData.organizationId || userData.organizationId,
          userId: newData.userId || userData.userId,
        };
        fetch(`${BASE_URL}/BusinessUnits`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
          },
          body: JSON.stringify(data),
        })
          .then((response) => {
            if (!response.ok) {
              alert(`Error: Unable to update the client details. Status: ${response.status}`);
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
            response.json();
          })
          .then((data) => {
            alert("Client updated successfully");
            handleClose();
          })
          .catch((error) => console.error("Error adding new value to the database:", error));
        setEditingData(null);
      }
    } else {
      const userDataJSON = localStorage.getItem("token");

      if (userDataJSON) {
        const userData = JSON.parse(userDataJSON);

        if (newData.businessUnit.trim() === "") {
          alert("Please enter a valid client.");
          return;
        }

        if (rows.some((row) => row.name === newData.businessUnit)) {
          alert("Client already exists.");
          return;
        }

        const data = {
          name: newData.businessUnit,
          adminUrl: newData.adminUrl,
          createdBy: userData.userName,
          isDefault: newData.isDefaultChecked,
          delete: false,
          createdDate: Date().substring(0, 25),
          organizationId: newData.organizationId || userData.organizationId,
          userId: newData.userId || userData.userId,
        };
        setRows((prevRows) => [
          ...prevRows,
          {
            ...newData,
            name: newData.businessUnit,
            isDefault: newData.isDefaultChecked,
            createdBy: userData.userName,
            createdDate: new Date().toISOString().substring(0, 25),
          },
        ]);
        fetch(`${BASE_URL}/BusinessUnits`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
          },
          body: JSON.stringify(data),
        })
          .then((response) => {
            if (!response.ok) {
              alert(`Error: Unable to create the client. Status: ${response.status}`);
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
            response.json();
          })
          .then((data) => {
            alert("New client created successfully");
            handleClose();
          })
          .catch((error) => console.error("Error adding new value to the database:", error));
      }
    }
    getBusinessUnits();
    handleClose();
  };
  const handleDelete = () => {
    const updatedRow = rows.filter((row) => row.id === selectDeletedItem);
    setIsPopupOpen(false);

    // Create the payload for the PUT request
    const payload = {
      businessUnitId: selectDeletedItem,
      name: updatedRow[0].name,
      modifiedBy: getUserIdFromLocalStorage().userName,
      delete: true,
      organizationId: getUserIdFromLocalStorage().organizationId,
      isDefault: false,
    };

    fetch(`${BASE_URL}/BusinessUnits`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${getUserIdFromLocalStorage().token}`,
        accept: "*/*",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        // First check if the response was successful
        if (!response.ok) {
          return response.text().then((text) => {
            throw new Error(
              `Server responded with status: ${response.status}, message: ${text || "No error message"}`
            );
          });
        }

        // Check if there's content before trying to parse JSON
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.includes("application/json")) {
          return response.json();
        } else {
          // If not JSON or empty response, return an empty object or appropriate value
          return {};
        }
      })
      .then((data) => {
        // The rest of your logic for updating the UI remains the same
        setRows((prevRows) => prevRows.filter((row) => row.id !== selectDeletedItem));
        const updatedRows = rows.filter((row) => row.id !== selectDeletedItem);

        // Calculate the new total pages
        totalPages = Math.ceil(updatedRows.length / dynamicRowsPerPage);

        // Determine if the current page should be adjusted
        let newCurrentPage = currentPage;
        if (currentPage > totalPages) {
          newCurrentPage = totalPages;
        } else if (currentPage === totalPages && updatedRows.length % dynamicRowsPerPage === 0) {
          newCurrentPage = currentPage - 1 > 0 ? currentPage - 1 : 1;
        }

        // Update the current page
        setCurrtPage(newCurrentPage);

        // Calculate and update the start and end indices based on the new current page
        const startIndex = (newCurrentPage - 1) * dynamicRowsPerPage;
        let endIndex = startIndex + dynamicRowsPerPage;
        endIndex = endIndex > updatedRows.length ? updatedRows.length : endIndex;

        setStartIndex(startIndex);
        setEndIndex(endIndex);
      })
      .catch((error) => console.error("Error updating data:", error));
  };

  useEffect(() => {
    setLoading(true);
    const userDataJSON = localStorage.getItem("token");

    if (userDataJSON) {
      const userData = JSON.parse(userDataJSON);
      // Fetching data from the backend server
      (async () => {
        try {
          const { getBusinessUnits } = await import("../../Utility/utility");
          const data = await getBusinessUnits(userData.organizationId);
          setLoading(false);
          console.log("Fetched Business Units Data:", defaultBusinessunit);
          setRows(
            data.filter((row) => {
              // Base condition - not deleted
              if (row.isDeleted === true) return false;

              // Local search filter (search box on the page)
              const matchesLocalSearch =
                searchValue === "" ||
                row.name.toLowerCase().includes(searchValue.toLowerCase()) ||
                (row.createdBy && row.createdBy.toLowerCase().includes(searchValue.toLowerCase()));

              // Global client filter (Search Client dropdown) - match by client name
              const matchesGlobalClient =
                !defaultBusinessunit ||
                row.name.toLowerCase() === defaultBusinessunit.toLowerCase();

              return matchesLocalSearch && matchesGlobalClient;
            })
          );
          // Here, you can transform the fetched data to match the format of your 'data' array.
        } catch (error) {
          console.error("Error fetching data:", error);
          setLoading(false); // Stop loading in case of error
        }
      })();
    }
    // getBusinessUnits();
  }, [searchValue, defaultBusinessunit]);

  // useEffect(() => {
  //   // Save to local storage whenever rows change

  //   localStorage.setItem('BusinessUnits', JSON.stringify(rows));
  //   const items = JSON.parse(localStorage.getItem('BusinessUnits'));
  // }, [rows]);

  useEffect(() => {
    setCurrtPage(1);
    setStartIndex(0);
    setEndIndex(dynamicRowsPerPage);
  }, [dynamicRowsPerPage]);

  const handlePageChange = (event, newPage) => {
    setCurrtPage(newPage);
    setStartIndex((parseInt(newPage) - 1) * dynamicRowsPerPage);
    setEndIndex((parseInt(newPage) - 1) * dynamicRowsPerPage + dynamicRowsPerPage);
  };

  let totalPages = Math.ceil(rows.length / dynamicRowsPerPage);
  const filteredRows = rows.filter((row) =>
    (row.businessUnit?.toLowerCase() || "").includes(searchValue.toLowerCase())
  );
  return (
    <>
      <div className={screenHeaderStyle(isMenuOpen)}>
        <div
          style={{
            marginTop: paddingAndMargin.headerTopHeight,
            marginBottom: paddingAndMargin.headerBelowHeight,
            backgroundColor: "transparent",
            alignItems: "center",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <SearchInput
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
            }}
            onClick={() => {
              setSearchValue("");
            }}
          />
          <Button
            onClick={() => {
              setOpen(true);
              setTitle("Create New Client");
            }}
            className="review-btn-filled"
            variant="contained"
          >
            Add Client
          </Button>
        </div>

        {/* Main container for table with fixed height */}
        <div style={{ height: "calc(100vh - 220px)", display: "flex", flexDirection: "column" }}>
          {/* Columns - Fixed Header */}
          <div className="columntitlesRowStyle" style={{ flexShrink: 0 }}>
            {columns.map((column) => (
              <div key={column.field} className="columntitlesStyle">
                <UpperLowerText text={column.headerName} />
              </div>
            ))}
          </div>

          {/* Scrollable rows container */}
          <div ref={scrollContainerRef} style={{ flex: 1, overflowY: "auto" }}>
            {loading ? (
              <div
                style={{
                  textAlign: "center",
                  fontSize: "18px",
                  color: "#555",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <LoaderIndicator />
              </div>
            ) : rows.length === 0 ? (
              <div className="no-record">There are no clients available.</div>
            ) : (
              <div>
                {rows.slice(startIndex, endIndex).map((row) => (
                  <div key={row.id} className="columnRowStyle">
                    {columns.map((column) => (
                      <div
                        key={column.field}
                        title={column.field !== "functions" ? row[column.field] : undefined}
                        className="columnValuesStyle"
                      >
                        {column.field === "functions" ? (
                          <div style={{ display: "flex", alignItems: "flex-end" }}>
                            <div style={{ marginRight: "auto" }}></div>
                            <EditButton
                              onClick={() => {
                                handleEdit(row.id, row.name, row.isDefault);
                                setTitle("Edit client");
                              }}
                            />
                            <DeleteButton
                              onClick={() => {
                                setIsPopupOpen(true);
                                setSelectDeletedItem(row.id);
                              }}
                            />
                          </div>
                        ) : column.headerName === "Modified Date" && row[column.field] != null ? (
                          formatDate(row[column.field])
                        ) : column.headerName === "Created Date" ? (
                          formatDate(row[column.field])
                        ) : column.headerName === "Default" && row[column.field] == true ? (
                          <div style={{ display: "flex", paddingLeft: 15 }}>
                            {" "}
                            <CheckIcon style={{ color: "#2aa7e0" }} />
                          </div>
                        ) : (
                          row[column.field]
                        )}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* The div that fills the remaining height */}
        {/* <div style={{ flex: 1, backgroundColor: 'white', marginBottom: '10px', marginLeft: '10px', marginRight: '10px' }}></div> */}
        <BusinessModalComponent
          show={open}
          handleClose={handleClose}
          onSave={handleSave}
          editingData={editingData}
          title={title}
        />
        <DeleteModal
          open={isPopupOpen}
          isDeleting={false}
          onClose={() => setIsPopupOpen(false)}
          onDelete={handleDelete}
        />
      </div>
      <ConditionalPagination
        itemCount={rows.length}
        itemsPerPage={dynamicRowsPerPage}
        threshold={dynamicRowsPerPage}
        paginationProps={{
          page: currentPage,
          onChange: handlePageChange,
          style: paginationstyle,
          sx: paginationStyles,
          hidePrevButton: false,
          hideNextButton: false,
          showFirstButton: true,
          showLastButton: true,
        }}
      />
    </>
  );
}
